import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, Observable, throwError } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class LogoService {
  constructor(private http: HttpClient) {}

  public getLogos(): Observable<any[]> {
    return this.http
      .get<any[]>('/settings/GetLogos')
      .pipe(catchError(this.handleError))
  }

  public saveLogo(request: any): Observable<any> {
    return this.http
      .post('/settings/UpdateLogo', request)
      .pipe(catchError(this.handleError))
  }

  handleError(error) {
    let errorMessage = ''
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`
    }
   // console.log(errorMessage)
    return throwError(errorMessage)
  }
}
